import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-notification-email',
	path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
	exact: true,
};
